<template>
  <div id="contenedor-agregar-nuevo-presupuesto">
    <v-form ref="registrarNuevoPresupuesto" v-model="formPptoValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar Nuevo Presupuesto
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row justify="center" align="center">
          <custom-select
            cols="12" sm="12" md="3"
            v-model="presupuesto.ejercicio"
            label="Ejercicio"
            :items="ejercicios"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-select
            cols="12" md="5"
            v-model="presupuesto.idFuenteFinanciera"
            label="Fuente financiera*"
            :items="fuentesFinancieras"
            item-text="nombre"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-text-field-green
            cols="12" sm="12" md="4"
            v-model.number="presupuesto.importe"
            label="Importe"
            prefix="$"
            :value="null"
            :rules="[mixReglas.notNull]"
            type="number">
          </custom-text-field-green>
          <!-- <v-col cols="12" md="2" class="py-0">
            <v-checkbox
              v-model="presupuesto.esPresupuestoOriginal"
              label="Presupuesto Original"
              hide-details
              class="mt-0">
            </v-checkbox>
          </v-col> -->
        </v-row>
        <agregar-detalle-presupuesto
          :detalles="presupuesto.detalles"
          v-model="formPptoDetalleValido" />
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarPresupuesto"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
// import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomSelect from '@/components/inputs/Select.vue';
// import CustomTextArea from '@/components/inputs/TextArea.vue';
// import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixPresupuestos from './mixPresupuestos';
import agregarDetallePresupuesto from './presupuestosDetalles/Nuevo.vue';

export default {
  name: 'NuevoPresupuesto',
  mixins: [mixPresupuestos],
  components: {
    // CustomTextField,
    CustomTextFieldGreen,
    CustomSelect,
    // CustomTextArea,
    // CustomDatePicker,
    CustomButton,
    agregarDetallePresupuesto,
  },
  data() {
    return {
      formPptoValido: false,
      formPptoDetalleValido: false,
      enviandoFormulario: false,
      presupuesto: {
        ejercicio: '', // Int!,
        idFuenteFinanciera: '', // ID!,
        esPresupuestoOriginal: false, // Boolean,
        importe: null, // Float!,
        detalles: [], // [inputPresupuestoDetalleObra!],
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoPresupuesto.reset();
    },
  },
  computed: {
    formularioValido() {
      if (this.presupuesto.detalles.length === 0) {
        return this.formPptoValido;
      }
      return this.formPptoValido && this.formPptoDetalleValido;
    },
  },
};
</script>
